/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardInfo
 */
export interface CardInfo {
    /**
     * Card Type<br/>0 = CB.<br/>1 = Visa.<br/>2 = Mastercard.<br/>
     * @type {number}
     * @memberof CardInfo
     */
    cardType: CardInfoCardTypeEnum;
    /**
     * Card Number
     * @type {string}
     * @memberof CardInfo
     */
    cardNumber: string;
    /**
     * CVV Code (back of the card)
     * @type {string}
     * @memberof CardInfo
     */
    cardCode: string;
    /**
     * Card Expiration Date
     * @type {string}
     * @memberof CardInfo
     */
    cardDate: string;
}


/**
 * @export
 */
export const CardInfoCardTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type CardInfoCardTypeEnum = typeof CardInfoCardTypeEnum[keyof typeof CardInfoCardTypeEnum];


/**
 * Check if a given object implements the CardInfo interface.
 */
export function instanceOfCardInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cardType" in value;
    isInstance = isInstance && "cardNumber" in value;
    isInstance = isInstance && "cardCode" in value;
    isInstance = isInstance && "cardDate" in value;

    return isInstance;
}

export function CardInfoFromJSON(json: any): CardInfo {
    return CardInfoFromJSONTyped(json, false);
}

export function CardInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardType': json['cardType'],
        'cardNumber': json['cardNumber'],
        'cardCode': json['cardCode'],
        'cardDate': json['cardDate'],
    };
}

export function CardInfoToJSON(value?: CardInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardType': value.cardType,
        'cardNumber': value.cardNumber,
        'cardCode': value.cardCode,
        'cardDate': value.cardDate,
    };
}

